import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { propTypes, reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { Card, CardActions } from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import CircularProgress from 'material-ui/CircularProgress'

import { profileRequest, profileEdit } from '../reducers'

import defaultTheme from 'admin-on-rest'
import { userLogin as userLoginAction } from 'admin-on-rest'
import { translate } from 'admin-on-rest'
import { Notification, ViewTitle } from 'admin-on-rest'

import { createHashHistory } from 'history'
export const history = createHashHistory()

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    minWidth: 300,
  },
  avatar: {
    margin: '1em',
    textAlign: 'center ',
  },
  form: {
    padding: '0 1em 1em 1em',
  },
  input: {
    display: 'flex',
  },
}

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
  meta: { touched, error } = {},
  input: { ...inputProps },
  ...props
}) => {
  // console.log('renderinouyt')
  // console.log('state' + inputProps)
  return (
    <TextField
      errorText={touched && error}
      {...inputProps}
      {...props}
      fullWidth
    />
  )
}

class StudentProfile extends Component {
  constructor(props) {
    super(props)

    this.studentFields = {
      email: {
        label: 'Email',
        required: true,
        disabled: true,
      },
      password: {
        label: 'Parola',
        type: 'password',
        required: true,
        disabled: true,
      },
      firstName: {
        label: 'Prenume',
        required: true,
      },
      lastName: {
        label: 'Nume de familie',
        required: true,
      },
      cnp: {
        label: 'CNP',
        required: true,
        // disabled: true,
      },
      phoneNumber: {
        label: 'Telefon de contact',
        required: true,
        // disabled: true,
      },
      school: {
        label: 'Scoala',
      },
      speciality: {
        label: 'Specialitatea',
      },
      workplace: {
        label: 'Locul de munca',
      },
      city: {
        label: 'Localitatea',
      },
      clinic: {
        label: 'Clinica',
      },
      section: {
        label: 'Sectia(compartiment)',
      },
    }

    this.requiredFields = Object.keys(this.studentFields).filter(
      key =>
        this.studentFields.hasOwnProperty('required') &&
        this.studentFields.required &&
        !(
          this.studentFields.hasOwnProperty('disabled') &&
          this.studentFields.disabled
        ),
    )
  }

  componentDidMount = () => {
    this.props.profileRequest()
  }

  edit = formData => this.props.profileEdit(formData)

  render() {
    const { handleSubmit, submitting, theme, translate } = this.props
    const muiTheme = getMuiTheme(theme)
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={{ ...styles }}>
          <Card style={styles.card}>
            <ViewTitle title={'Profilul meu'} />
            <form onSubmit={handleSubmit(this.edit)}>
              <div style={styles.form}>
                {Object.keys(this.studentFields).map(key => (
                  <div style={styles.input} key={key}>
                    <Field
                      name={key}
                      component={renderInput}
                      type={this.studentFields[key]['type']}
                      floatingLabelText={this.studentFields[key]['label']}
                      disabled={
                        submitting || this.studentFields[key]['disabled']
                      }
                    />
                  </div>
                ))}
              </div>
              <CardActions>
                <RaisedButton
                  type="submit"
                  primary
                  disabled={submitting}
                  icon={
                    submitting && <CircularProgress size={25} thickness={2} />
                  }
                  label={translate('aor.auth.edit_account')}
                  fullWidth
                />
              </CardActions>
            </form>
          </Card>
          <Notification />
        </div>
      </MuiThemeProvider>
    )
  }
}

StudentProfile.propTypes = {
  ...propTypes,
  authClient: PropTypes.func,
  previousRoute: PropTypes.string,
  // theme: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  userLogin: PropTypes.func.isRequired,
}

StudentProfile.defaultProps = {
  theme: defaultTheme,
}

// const mapStateToProps = state => {
//   return {
//     initialValues: state.student.profile,
//   }
// }

const enhance = compose(
  translate,
  connect(
    state => ({
      initialValues: state.students.profile,
    }),
    {
      userLogin: userLoginAction,
      profileRequest,
      profileEdit,
    },
  ),
  reduxForm({
    form: 'editProfile',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props

      const requiredFields = [
        'firstName',
        'lastName',
        // 'email',
        'cnp',
        // 'phoneNumber',
        // 'password',
      ]
      requiredFields.forEach(field => {
        if (!values[field]) {
          errors[field] = translate('aor.validation.required')
        }
      })

      if (
        values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = translate('aor.validation.invalidEmail')
      }

      return errors
    },
  }),
)
// http://redux-form.com/6.4.3/examples/initializeFromState/
export default enhance(StudentProfile)



// WEBPACK FOOTER //
// ./src/students/StudentProfile.js